import { render, staticRenderFns } from "./BgUploadModalView.vue?vue&type=template&id=2cb7b714"
import script from "./BgUploadModalView.vue?vue&type=script&lang=js"
export * from "./BgUploadModalView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports